import React from 'react';
import Doubts from '../../components/doubts';
import Footer from '../../components/footer';
import { Formations } from '../../components/formations';
import Navbar from '../../components/navbar';
import Numbers from '../../components/numbers';
import Partners from '../../components/partners';
import { SlideshowHome } from '../../components/slideshow';
import Testimonials from '../../components/testimonials';

function Home (){
    return(        
        <body>
        <Navbar/>
        <hr className='hr-min'/>
        <SlideshowHome/>
        <hr className='hr-min'/>
        <Numbers/>
        <hr className='hr-max'/>
        <Formations/>
        <hr className='hr-max'/>
        <Testimonials/>
        <hr className='hr-max'/>
        <Partners/>
        <hr className='hr-max'/>
        <Doubts/>
        <Footer/>
        </body>
    )
}
export default Home;